@let isLoading = analysisStateService.configurations.isLoading();
<pm-form-field label="ANALYSIS.ERROR_CONFIGURATION">
  <pm-form-input-select
    [disabled]="isLoading"
    [ngModel]="selectedAnalysisConfigurationId()"
    (ngModelChange)="configurationSelectionChanged($event)"
    [data]="analysisConfigurationOptions()"
  >
    <div *pmFormInputSelection="let option = node" class="flex flex-col w-full">
      <span class="min-w-0 flex-1 truncate">
        {{ option.label }}
      </span>
      <span class="text-content-subdued text-xs">
        {{ option.descriptionKey | translate }}
      </span>
    </div>
  </pm-form-input-select>
</pm-form-field>
